<div>
  <div *ngIf="!dpsUnavailable" class="text p-5">{{ 'payee.denied.denied' | translate }}</div>
  <div *ngIf="dpsUnavailable" class="text p-5">{{ 'payee.denied.unavailable' | translate }}</div>
  <button *ngIf="!isAdjuster" class="upsc-button" [class.top-spacing]="dangerNotification" routerLink="/claims/payee">{{ 'payee.banking.button' | translate }}</button>
  <button *ngIf="isAdjuster" class="upsc-button" [class.top-spacing]="dangerNotification" routerLink="/adjusterDashboard">{{ 'payee.banking.adjusterButton' | translate }}</button>
</div>